//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import ChildFormArray from "../../../parent-flow/forms/ChildFormArray";
import { useFormSubmission } from "../../../../utils/hooks";
import { FormContainer } from "../../components/FormWrapper";
import { RequestDataContext } from "../../RequestDataProvider";
import {
  ChildrenStore,
  formatClass,
  formatValue,
  transformOutput,
} from "../../store";
import { IViewModelReturnType } from "../store";

export { formatClass, formatValue };
export { ChildrenStore };
const transformInput = (inputArr) => {
  let result = {};
  let transformedInput = inputArr.map((child) => {
    let {
      classDetail: { class: studentClass, purpose, subjects },
    } = child;

    let newClassDetail = {
      class: studentClass.split(" ").join(""),
      purpose: purpose.split(" ").join("_"),
      subjects: subjects.map((subject) => subject.split(" ").join("_")),
    };

    return { ...child, classDetail: newClassDetail };
  });

  return { ...result, childDetails: transformedInput };
};
export function useChildFormHook(toNextPage, onSubmit, sessionID) {
  const {
    onUpdateChildDetail,
    requestData: { childDetails },
    isOneTeacherOption,
  }: any = useContext(RequestDataContext);

  let inputValue = childDetails.length > 0 ? transformInput(childDetails) : "";
  const onSubmitForm = (data) => {
    let transformedOutput = transformOutput(data);
    let fullData = onUpdateChildDetail(transformedOutput);
    return fullData;
  };
  let [loading, handleSubmit] = useFormSubmission(
    onSubmit,
    toNextPage,
    onSubmitForm,
    sessionID,
    [isOneTeacherOption]
  );

  return { handleSubmit, inputValue, loading };
}
type ChildFormPageProps = {
  toNextPage: (data?: any) => Promise<any>;
  dataType: any;
  viewModel: IViewModelReturnType["childStore"];
  customerType: IViewModelReturnType["customerType"];
  loading: boolean;
  updateFormIndex: () => void;
  displayGender?: boolean;
  nextButtonText?: string;
  path?: string;
  canSelectChild?: boolean;
};
const ChildFormPage = observer(
  ({
    toNextPage,
    dataType,
    path,
    customerType,
    viewModel,
    loading,
    updateFormIndex,
    nextButtonText,
    displayGender,
    canSelectChild,
    ...rest
  }: ChildFormPageProps) => {
    const isParent = customerType === "parent";
    const formCopy = {
      heading: isParent
        ? "Tell us about your child"
        : "Tell us your learning goal",
      description: isParent
        ? "Every child learns differently. Add a few details about your child to help us understand their needs and create the right learning plan to achieve your goals."
        : "Everyone learns differently. Add a few details about you to help us understand your needs and create the right learning plan to achieve your goals.",
    };

    return (
      <FormContainer {...formCopy} {...rest}>
        <ChildFormArray
          updateFormIndex={updateFormIndex}
          dataType={dataType}
          customerType={customerType}
          loading={loading}
          onNextClick={toNextPage}
          path={path}
          nextButtonText={nextButtonText}
          viewModel={viewModel}
          displayGender={displayGender}
          value={viewModel.inputValue}
          onSubmit={viewModel.onSubmitForm}
          canSelectChild={canSelectChild}
        />
      </FormContainer>
    );
  }
);

export default ChildFormPage;
